import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { voteHeadActions } from "../slices/voteHead";
import { getErrorMessage } from "../../utils/errorUtils";
import { VoteHeadRequestDto } from "../../shared/dtos/voteHead/VoteHeadRequestDto";
import { VoteHeadResponseDto } from "../../shared/dtos/voteHead/VoteHeadResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const createVoteHead =
  (values: VoteHeadRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(voteHeadActions.setLoadingCreate());
    try {
      const { data } = await axiosInstance.post<
        ApiResponseDto<VoteHeadResponseDto>
      >("/vote-heads", values, { headers: { requiresAuth: true } });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Vote head created successfully!");
        dispatch(voteHeadActions.createSuccess(data.data));
        dispatch(
          voteHeadActions.setServerStatus({
            operation: "create",
            status: data.statusCode || 201,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(voteHeadActions.setErrorCreate(message));
    }
  };

export const getVoteHeads = () => async (dispatch: AppDispatch) => {
  dispatch(voteHeadActions.setLoadingFetchAll());
  try {
    const { data } = await axiosInstance.get<
      ApiResponseDto<VoteHeadResponseDto[]>
    >("/vote-heads", { headers: { requiresAuth: true } });

    if (data.status === ApiResponseStatus.SUCCESS && data.data) {
      dispatch(voteHeadActions.setItems(data.data));
    }
  } catch (error) {
    dispatch(voteHeadActions.setErrorFetchAll(getErrorMessage(error)));
  }
};

export const getVoteHeadById =
  (id: string) => async (dispatch: AppDispatch) => {
    dispatch(voteHeadActions.setLoadingFetchOne());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<VoteHeadResponseDto>
      >(`/vote-heads/${id}`, { headers: { requiresAuth: true } });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(voteHeadActions.setItem(data.data));
      }
    } catch (error) {
      dispatch(voteHeadActions.setErrorFetchOne(getErrorMessage(error)));
    }
  };

export const updateVoteHead =
  (payload: { id: string; values: VoteHeadRequestDto }) =>
  async (dispatch: AppDispatch) => {
    dispatch(voteHeadActions.setLoadingUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<VoteHeadResponseDto>
      >(`/vote-heads/${payload.id}`, payload.values, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Vote head updated successfully!");
        dispatch(voteHeadActions.updateSuccess(data.data));
        dispatch(
          voteHeadActions.setServerStatus({
            operation: "update",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(voteHeadActions.setErrorUpdate(message));
    }
  };

export const deleteVoteHead = (id: string) => async (dispatch: AppDispatch) => {
  dispatch(voteHeadActions.setLoadingDelete());
  try {
    const { data } = await axiosInstance.delete<ApiResponseDto<void>>(
      `/vote-heads/${id}`,
      { headers: { requiresAuth: true } },
    );

    if (data.status === ApiResponseStatus.SUCCESS) {
      toast.success(data.message || "Vote head deleted successfully!");
      dispatch(voteHeadActions.deleteSuccess(id));
      dispatch(
        voteHeadActions.setServerStatus({
          operation: "delete",
          status: data.statusCode || 200,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(voteHeadActions.setErrorDelete(message));
  }
};

export const resetVoteHeadServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(voteHeadActions.setServerStatus(null));
};
